import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { CustomerDisputeDetail, StaffCustomerViewService } from '../services/staff-customer-view.service';

@Component({
    selector: 'app-customer-support-dispute-detail',
    standalone: true,
    imports: [CommonModule, RouterModule, TableModule, ButtonModule, TagModule, ToastModule, ToolbarModule],
    providers: [MessageService],
    templateUrl: './customer-support-dispute-detail.component.html',
    styleUrl: './customer-support-dispute-detail.component.scss'
})
export class CustomerSupportDisputeDetailComponent implements OnInit {
    customerId = '';
    claimNumber = '';
    company = '';
    division = '';

    detail: CustomerDisputeDetail | null = null;
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private staffCustomerViewService: StaffCustomerViewService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {
        this.customerId = this.route.snapshot.paramMap.get('customerId') || '';
        this.claimNumber = this.route.snapshot.paramMap.get('claimNumber') || '';
        this.company = this.route.snapshot.queryParamMap.get('company') || '';
        this.division = this.route.snapshot.queryParamMap.get('division') || '';

        if (!this.customerId || !this.claimNumber) {
            this.backToSupport();
            return;
        }
        this.load();
    }

    load(): void {
        this.loading = true;
        this.staffCustomerViewService
            .getDisputeDetail(this.customerId, this.claimNumber)
            .pipe(finalize(() => (this.loading = false)))
            .subscribe({
                next: (detail) => (this.detail = detail),
                error: (err) => this.showError('Failed to load dispute', err)
            });
    }

    openOrder(): void {
        if (!this.detail?.orderNumber) return;
        this.router.navigate(
            ['/customer-support', this.customerId, 'orders', this.detail.orderNumber],
            { queryParams: { company: this.company, division: this.division } }
        );
    }

    backToSupport(): void {
        this.router.navigate(['/customer-support'], {
            queryParams: { customerId: this.customerId || undefined }
        });
    }

    formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }

    private showError(summary: string, err: unknown): void {
        const detail =
            typeof (err as { error?: unknown })?.error === 'string'
                ? ((err as { error: string }).error as string)
                : (err as { message?: string })?.message || 'Unexpected error';
        this.messageService.add({ severity: 'error', summary, detail });
    }
}
